import Calendar from "@/Calendar";
import Field from "@/Field";
import IconButton from "@/IconButton";
import Popover from "@/Popover";
import { Calendar as CalendarIcon } from "lucide-react";
import React, { useState } from "react";
import { format as formatDateFns, parse as parseDateFns } from "date-fns";
import { FieldProps } from "@/Field/Field";
import { CalendarProps } from "@/Calendar/Calendar";

type DatePickerFieldProps = {
  value?: string;
  onChange?: (date: string) => void;
  format?: string;
  placeholder?: string;
  label?: FieldProps["label"];
  calenderProps?: CalendarProps;
};

const DatePickerField = (props: DatePickerFieldProps) => {
  const {
    value,
    onChange,
    format = "yyyy-MM-dd",
    placeholder,
    label,
    calenderProps,
  } = props;
  //@ts-expect-error
  const [date, setDate] = useState<Date | undefined>(value || undefined);
  const [open, setOpen] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    const parsed = parseDateFns(val, format, new Date());
    setDate(parsed);
  };

  const handleCalendarChange = (selectedDate: Date | undefined) => {
    if (!selectedDate) {
      setDate(undefined);
    } else {
      setDate(selectedDate);
      if (typeof onChange === "function") {
        onChange(formatDateFns(selectedDate, "yyyy-MM-dd"));
      }
    }

    setOpen(false);
  };

  // const open = Boolean(anchorEl);

  const formattedDate =
    date && !isNaN(date.getTime()) ? formatDateFns(date, format) : "";
  return (
    <Field
      type="text"
      label={label || "Date"}
      readOnly
      className="input-no-calendar"
      value={formattedDate}
      //@ts-expect-error
      onChange={handleInputChange}
      placeholder={placeholder || format}
      endAdornment={
        <Popover
          className="!p-0"
          open={open}
          onOpenChange={setOpen}
          align="end"
          trigger={
            <IconButton color="primary" variant="text" title="Calender">
              <CalendarIcon />
            </IconButton>
          }
        >
          <Calendar
            value={date}
            onChange={handleCalendarChange}
            className="!shadow-none !border-none"
            {...calenderProps} // Spread additional calendar props
          />
        </Popover>
      }
    />
  );
};

export default DatePickerField;
